import script from "./AdvertSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvertSetup.vue?vue&type=script&setup=true&lang=js"

import "./AdvertSetup.vue?vue&type=style&index=0&id=aca3d1c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aca3d1c8"]])

export default __exports__